export function escapeHtml(value = '') {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function sanitizeUrl(url) {
  if (!url || typeof url !== 'string') {
    return null;
  }

  if (url.startsWith('/')) {
    return url;
  }

  try {
    const parsed = new URL(url);
    return ['http:', 'https:'].includes(parsed.protocol) ? url : null;
  } catch {
    return null;
  }
}

export function html2text(html) {
  return escapeHtml(html);
}

export function parseAndSanitizeTextToParagraphs(text) {
  // Simple sanitization function to remove HTML tags
  function sanitize(input) {
    const div = document.createElement('div');
    div.textContent = input; // Assign textContent to escape HTML
    return div.innerHTML; // Returns sanitized text as plain HTML
  }

  // Split the text by double line breaks
  let paragraphs = text.split(/\n\s*\n/);

  // Sanitize and trim extra whitespace from each paragraph, filter out empty ones
  paragraphs = paragraphs
    .map(paragraph => sanitize(paragraph.trim()))
    .filter(paragraph => paragraph.length > 0);

  return paragraphs;
}
